import { useCallback, useState } from "react";

const TOUR_STORAGE_KEY = "hr-payslip-view-tour-completed";

export function usePayslipViewTour() {
  const [run, setRun] = useState(false);

  const startTour = useCallback(() => setRun(true), []);
  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(TOUR_STORAGE_KEY, "true");
    }
  }, []);

  const handleJoyrideCallback = useCallback(
    (data: { status?: string; type?: string }) => {
      if (
        data.status === "finished" ||
        data.status === "skipped" ||
        data.type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour],
  );

  return { run, startTour, stopTour, handleJoyrideCallback };
}
